import axios from 'axios';
import moment from 'moment';
import { EXCLUDED_OPERATING_CARRIER } from '../../const/Company';

export default {
  getPoints,
  getPointsPlusMoney
};

const GET_POINTS_V1 = 'exchange/api/v1/exchange/getPoints';
const AZUL_COMPANY_CODE = 'AD';
const GET_POINTS_PLUS_MONEY_V1 = 'exchange/api/v1/exchange/getPointsPlusMoney';
const GET_POINTS_PLUS_MONEY_V1_ADULT_RANGE = 'exchange/api/v1/exchange/getPointsPlusMoneyByRange/';

function getPoints(flight) {
  return new Promise(resolve => {
    const payload = createGetPointsRequestPayload(flight);

    if (payload.items.partner) {
      axios
        .post(GET_POINTS_V1, payload)
        .then(res => {
          if(!res.data || !res.data.value)
           throw Error();
          resolve({ points: res.data, isAvailable: true });
        }
        )
        .catch(err => {
          resolve({
            status: err.status,
            body: err.response && err.response.data ? err.response.data : null,
            error: true
          });
        });
    } else {
      resolve({
        isAvailable: false
      });
    }
  });
}

function getPointsPlusMoney(flight, rangePointsPlusMoney) {
  const URI = !rangePointsPlusMoney ? GET_POINTS_PLUS_MONEY_V1 : GET_POINTS_PLUS_MONEY_V1_ADULT_RANGE + rangePointsPlusMoney.id;

  return new Promise(resolve => {
    const payload = {
      items: {
        origin: flight.departureFlightAirport,
        destination: flight.arrivalFlightAirport,
        cabin: flight.cabin,
        partner: obtainPartner(flight.operatingCarriers),
        departureDate: formatDepartureDate(flight),
        classType: flight.classType,
        passengerType: returnEnumPassengerType(flight.passengerType)
      },
      value: {
        value: flight.value,
        currency: flight.currency
      }
    };
    axios
      .post(URI, payload)
      .then(res => {
        if (!res.data.points || !res.data.points.value)
          throw Error();
        resolve(res.data);
      }
      )
      .catch(err => {
        resolve({
          status: err.status,
          body: err.response && err.response.data ? err.response.data : null,
          error: true
        });
      });

  });
}

function obtainPartner(operationCarriers) {
  let partner;

  if (operationCarriers && operationCarriers.length > 0) {
    partner = operationCarriers.find(
      partner => partner !== AZUL_COMPANY_CODE && partner !== EXCLUDED_OPERATING_CARRIER
    );
    if (!partner) {
      partner = AZUL_COMPANY_CODE;
    }
  }
  return partner ? partner : null;
}

function formatDepartureDate(flight) {
  return moment(flight.departureFlightDate + flight.departureFlightTime, 'DD/MM/YYYYhh:mm').format(
    'YYYY-MM-DDTHH:mm:ss'
  );
}

function createGetPointsRequestPayload(flight) {
  return {
    items: {
      origin: flight.departureFlightAirport,
      destination: flight.arrivalFlightAirport,
      cabin: flight.cabin,
      partner: obtainPartner(flight.operatingCarriers),
      departureDate: formatDepartureDate(flight),
      classType: flight.classType,
      passengerType: returnEnumPassengerType(flight.passengerType)
    },
    value: {
      value: flight.value,
      currency: flight.currency
    }
  };
}

function returnEnumPassengerType(passengerType) {
  const passengerTypeEnum = {
    INFANT: 'INF',
    CHILD: 'CHD',
    ADULT: 'ADT'
  };
  return passengerTypeEnum[passengerType];
}



// WEBPACK FOOTER //
// ./src/services/exchange/ExchangeService.js